import { ReactNode, Suspense } from 'react';
import { createPortal } from 'react-dom';

import { IntegrationSuggestionBanner } from '@/components/IntegrationSuggestionBanner';
import { JobProgressProvider } from '@/hooks/useJobProgress';
import { AddAsset } from '@/sections/add/AddAsset';
import { AddFile } from '@/sections/add/AddFile';
import { AddRisks } from '@/sections/add/AddRisks';
import { UserAgentModal } from '@/sections/asset/components/modals';
import { AppDrawers } from '@/sections/drawers';
import JobProgressBar from '@/sections/jobs/components/JobProgressBar';
import { LinkAWS } from '@/sections/LinkAWS';
import { LinkAzure } from '@/sections/LinkAzure';
import { NewUserSeedModal } from '@/sections/NewUserSeedModal';
import { UpgradeModal } from '@/sections/Upgrade';
import { TicketModals } from '@/sections/vulnerabilities/components/TicketModals';

interface AuthenticatedAppProps {
  children: ReactNode;
}

function AuthenticatedAppComponent(props: AuthenticatedAppProps) {
  const { children } = props;

  return (
    <>
      <IntegrationSuggestionBanner />
      {children}
      <div className="absolute z-30">
        <NewUserSeedModal />
        <AddRisks />
        <AddAsset />
        <AddFile />
        <UpgradeModal />
        <LinkAWS />
        <LinkAzure />
        <AppDrawers />
        <TicketModals />
        <UserAgentModal />
      </div>
    </>
  );
}

const HeaderPortalSections = {
  BREADCRUMBS: 'header-breadcrumbs-section',
  EXTRA_CONTENT: 'header-extra-content-section',
};

export function RenderHeaderExtraContentSection({
  children,
}: {
  children: ReactNode;
}) {
  const ExtraContentSection = document.getElementById(
    HeaderPortalSections.EXTRA_CONTENT
  );

  if (!ExtraContentSection) {
    return null;
  }

  return createPortal(children, ExtraContentSection);
}

function AuthenticatedAppProviders(props: { children: ReactNode }) {
  return (
    <JobProgressProvider>
      {props.children}
      <Suspense fallback={null}>
        <JobProgressBar />
      </Suspense>
    </JobProgressProvider>
  );
}

export function AuthenticatedApp(props: AuthenticatedAppProps) {
  return (
    <AuthenticatedAppProviders>
      <AuthenticatedAppComponent {...props} />
    </AuthenticatedAppProviders>
  );
}
